export function getCurrentDateWithOwnYear(year: number): Date {
  return new Date(new Date().setFullYear(year));
}
